/* eslint-disable camelcase */
import settlementDialogController from "./settlementDialog/settlementDialog.controller";
import settlementDialogTemplate from "./settlementDialog/settlementDialog.html";
import manualInvoiceDialogController from "./manualInvoiceDialog/manualInvoiceDialog.controller";
import manualInvoiceDialogTemplate from "./manualInvoiceDialog/manualInvoiceDialog.html";

import { assignParams } from "../../core/utils";
import isNil from "lodash/fp/isNil";
import join from "lodash/fp/join";

class Controller {
  constructor(
    $injector,
    Events,
    $mdDialog,
    $stateParams,
    $state,
    $location,
    Sections,
    Upload
  ) {
    "ngInject";
    this.$state = $state;
    this.Events = Events;
    this.Upload = Upload;
    this.$mdDialog = $mdDialog;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.InvoiceItem = $injector.get("CorporateInvoiceItem");
    this.Corporate = $injector.get("Corporate");
    this.ActionLists = $injector.get("ActionLists");
    this.CorporateTransforms = $injector.get("CorporateTransforms");
    this.CorporateInvoiceTransforms = $injector.get(
      "CorporateInvoiceTransforms"
    );
    this.CorporateInvoiceExport = $injector.get("CorporateInvoiceExport");
    this.invoiceItemsFields = this.CorporateInvoiceTransforms.invoiceItemsFields;
    this.corporateInvoiceParams = {
      invoice: this.$stateParams.id,
      isCityRequired: false,
    };
    this.corporateInvoiceItemActions = this.ActionLists.all.corporateInvoiceItemActions;
    this.errorEvent = Events.eventsType.onShowErrorNotification;
    this.filterEvent = Events.getFilterEvent("corporateInvoiceItems");
    this.filters = this.CorporateInvoiceTransforms.filters;
    this.activeParams = $stateParams;
    this.sections = Sections.customersSections;

    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.get = (params) => {
      this.Corporate.getCorporateInvoiceItems(params).$promise.then(
        (response) => {
          this.items = this.CorporateInvoiceTransforms.justifyInvoiceItems(
            response.hits
          );
          this.total = isNil(response.total) ? 0 : response.total;
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.getActiveInvoiceItems = () => {
      const params = { invoice: this.$stateParams.id, active: true };
      this.Corporate.getCorporateInvoiceItems(params).$promise.then(
        (response) => {
          this.activeInvoiceItemsCount = response.total;
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.Corporate.getInvoiceInfo(this.$stateParams.id).$promise.then(
      (response) => {
        this.invoice = this.CorporateInvoiceTransforms.justify(response);
        if (this.invoice.status === "Final") {
          this.getActiveInvoiceItems();
        }
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    const params = assignParams({ invoice: this.$stateParams.id });

    const onEvent = (options) => {
      if (!isNil(options.type)) options.type = join(",", options.type);
      this.params = Object.assign(params, options);
      this.$location.search(params);
      this.get(params);
    };

    if (this.filterEvent) this.Events.on(this.filterEvent, onEvent);

    this.settle = () => {
      this.$mdDialog.show({
        controller: settlementDialogController,
        controllerAs: "$ctrl",
        template: settlementDialogTemplate,
        locals: {
          settledInvoice: this.invoice,
        },
      });
    };

    this.addInvoiceItem = () => {
      const additionTypes = this.CorporateInvoiceTransforms
        .additionInvoiceTypes;
      const confirm = this.$mdDialog.show({
        controller: manualInvoiceDialogController,
        controllerAs: "$ctrl",
        template: manualInvoiceDialogTemplate,
        locals: {
          type: "addition",
          types: additionTypes,
        },
      });

      confirm.then((obj) => {
        obj.invoice = this.invoice._id;

        this.InvoiceItem.post(obj).$promise.then(
          () => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Added manual invoice item created successfully",
            });
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      });
    };

    this.deductInvoiceItem = () => {
      const deductionTypes = this.CorporateInvoiceTransforms
        .deductionInvoiceTypes;
      const confirm = this.$mdDialog.show({
        controller: manualInvoiceDialogController,
        controllerAs: "$ctrl",
        template: manualInvoiceDialogTemplate,
        locals: {
          type: "deduction",
          types: deductionTypes,
        },
      });

      confirm.then((obj) => {
        obj.invoice = this.invoice._id;

        this.InvoiceItem.post(obj).$promise.then(
          () => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Deduction manual invoice item created successfully",
            });
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      });
    };
    this.exportingInvoice = () => {
      const activeItemsParam = assignParams({
        invoice: this.$stateParams.id,
        active: true,
        limit: this.activeInvoiceItemsCount,
      });
      this.Corporate.getCorporateInvoiceItems(activeItemsParam).$promise.then(
        (response) => {
          const activeInvoiceItems = this.CorporateInvoiceTransforms.justifyInvoiceItems(
            response.hits
          );
          this.CorporateInvoiceTransforms.justifyInvoiceExporting(
            activeInvoiceItems,
            this.invoice
          );
          this.CorporateInvoiceExport.exportInvoice(this.invoice);
          this.CorporateInvoiceTransforms.summaryTableBody = [];
          this.CorporateInvoiceTransforms.detailsTableBody = [];
          this.CorporateInvoiceTransforms.infoTableBody = [];
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoice/corporateInvoice.controller.js